export default Object.freeze({
  /**
   * 쇼핑몰 정보 조회(shoplus_service)
   */
  "/users/info": {
    path: "/users/{1}/info",
    method: "GET",
  },
  /**
   * 상품 조회(shoplus_service)
   */
  "/api/cert/partners/products/search": {
    path: "/app/{0}/shoplus/{1}/api/cert/partners/products/search",
    method: "GET",
  },
  /**
   * 상품 등록(shoplus_service)
   */
  "/api/cert/partners/products": {
    path: "/app/{0}/shoplus/{1}/api/cert/partners/products",
    method: "POST",
  },
  /**
   * 상품 수정(shoplus_service)
   */
  "/api/cert/partners/products/code": {
    path: "/app/{0}/shoplus/{1}/api/cert/partners/products/{2}",
    method: "PUT",
  },
  /**
   * 상품 엑셀 등록(shoplus_service)
   */
  "/api/cert/partners/products/excel": {
    path: "/app/{0}/shoplus/{1}/api/cert/partners/products/excel",
    method: "POST",
  },
  /**
   * 상품 이미지 등록(shoplus_service)
   */
  "/api/cert/partners/products/images/code": {
    path: "/app/{0}/shoplus/{1}/api/cert/partners/products/{2}/images",
    method: "POST",
  },
  /**
   * 쇼핑몰 정보 수정(shoplus_service)
   */
  "/put/users/info": {
    path: "/users/{1}/info",
    method: "PUT",
  },
  /**
   * 쇼핑몰 회원가입(shoplus_service)
   */
  "/users/signup": {
    path: "/users/signup",
    method: "POST",
  },
  /**
   * 쇼핑몰 로그인(shoplus_service)
   */
  "/users/login": {
    path: "/users/login",
    method: "POST",
  },
  /**
   * 쇼핑몰 아이디 찾기 / 비밀번호 찾기 메일 발송(shoplus_service)
   */
  "/users/email/send": {
    path: "/users/email/send",
    method: "POST",
  },
  /**
   * 쇼핑몰 비밀번호 변경(shoplus_service)
   */
  "/users/password/update": {
    path: "/users/password/update",
    method: "POST",
  },
  /**
   * 쇼핑몰 앱 사용기간 조회(shoplus_service)
   */
  "/users/appExpire": {
    path: "/users/{1}/appExpire/{0}",
    method: "GET",
  },

  /**
   * 쇼핑몰 결제(shoplus_service)
   */
  "/api/cert/partners/paymnet": {
    path: "/app/{0}/shoplus/{1}/api/cert/partners/paymnet",
    method: "POST",
  },
  /**
   * 엑세스토큰 재발급 RefreshToken(shoplus_service)
   */
  "/shoplus/auth/refresh": {
    path: "/app/shoplus/{1}/auth/refresh",
    method: "POST",
  },

  /**
   * 상품조회
   */
  "/cert/products/search": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/search",
    method: "GET",
  },
  /**
   * 인증코드 상품 조회
   */
  "/cert/serials/search": {
    path: "/app/{0}/shoplus/{1}/api//cert/products/serials/search",
    method: "GET",
  },
  /**
   * 정품인증 시리얼 생성
   */
  "/generate/serials": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/generate/serials",
    method: "POST",
  },
  /**
   * 정품인증 시리얼 생성 엑셀
   */
  "/generate/serials/excel": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/generate/serials/excel",
    method: "POST",
  },
  "/serials/del": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/serials",
    method: "DELETE",
  },
  /**
   * 정품인증 상태 변경
   */
  "/serials/status": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/serials/{2}/status",
    method: "PUT",
  },
  /**
   * 정품인증 기간 변경
   */
  "/serials/range": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/serials/{2}/range",
    method: "PUT",
  },
  /**
   * 정품인증 설정 기간 변경
   */
  "/serials/duration": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/serials/{2}/duration",
    method: "PUT",
  },
  /**
   * 정품인증 히스토리
   */
  "/serials/history": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/serials/{2}/history",
    method: "GET",
  },
  /**
   * 분실상품 리스트
   */
  "/lost/search": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/lost/serials/search",
    method: "GET",
  },
  /**
   * 회원 체크
   */
  "/user/validate": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/user/{2}/validate",
    method: "GET",
  },
  /**
   * 정품인증기간 가져오기
   */
  "/get/duration": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/config/duration",
    method: "GET",
  },
  /**
   * 정품인증기간 등록
   */
  "/put/duration": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/config/duration",
    method: "PUT",
  },
  /**
   * sms설정 가져오기
   */
  "/get/config/sms": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/config/sms",
    method: "GET",
  },
  /**
   * sms설정 셋팅
   */
  "/put/config/sms": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/config/sms",
    method: "PUT",
  },
  /**
   * sms 발송 이력
   */
  "/lost/serials/sms": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/lost/serials/{2}/sms",
    method: "GET",
  },
  /**
   * sms 발송 이력
   */
  "/lost/serials/trial": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/lost/serials/{2}/trial",
    method: "GET",
  },
  /**
   * QR 코드 인쇄 설정 가져오기
   */
  "/get/print": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/config/print",
    method: "GET",
  },
  /**
   * QR 코드 인쇄 설정 등록.
   */
  "/put/print": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/config/print",
    method: "PUT",
  },
  /**
   * QR 코드 이미지 업로드
   */
  "/post/print": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/config/print/images",
    method: "POST",
  },
  /**
   * QR 노출 문구 설정 정보 가져오기
   */
  "/get/description": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/config/description",
    method: "GET",
  },
  /**
   * QR 노출 문구 설정 등록
   */
  "/put/description": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/config/description",
    method: "PUT",
  },
  /**
   * 결제 관리 입력 정보 조회
   */
  "/api/orders/latest": {
    path: "/app/{0}/shoplus/{1}/api/orders/latest",
    method: "GET",
  },
  /**
   * 결제 리스트
   */
  "/api/payments": {
    path: "/app/{0}/shoplus/{1}/api/payments",
    method: "GET",
  },
  /**
   * 결제 타입리스트
   */
  "/api/orders/types": {
    path: "/app/{0}/shoplus/{1}/api/orders/types",
    method: "GET",
  },
  /**
   * 결제
   */
  "/api/orders": {
    path: "/app/{0}/shoplus/{1}/api/orders",
    method: "POST",
  },
  "/exists/serials/excel": {
    path: "/app/{0}/shoplus/{1}/api/cert/products/exists/serials/excel",
    method: "POST",
  },
});
